
// import React, { useState } from 'react';

// function Services({
//     serviceContent,
//     LanguageSelected,
//     t,
//     ImageUrl,
//     hashedUserId,
//     FindServiceModal,
//     setFindServiceModal,
//     img5, divstyle
// }) {
//     const [activeIndex, setActiveIndex] = useState(0)
//     const [FindServiceInfo, setFindServiceInfo] = useState(null)

//     const goToPrev = () => {
//         setActiveIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : serviceContent.length - 1));
//     };

//     const goToNext = () => {
//         setActiveIndex((prevIndex) => (prevIndex < serviceContent.length - 1 ? prevIndex + 1 : 0));
//     };

//     return (
//         <div>
//             {serviceContent && serviceContent.length > 0 && (
//                 <>
//                     <div className={`pt-5 pb-5 pl-3 pr-3  relative ${divstyle} w-full`}>
//                         <h1
//                             className={`${LanguageSelected == 'ar'
//                                 ? 'title title--h1 first-title title__separate text-theme right-2'
//                                 : 'title left-2 title--h1 first-title title__separate text-theme'
//                                 }`}
//                         >
//                             {t("Produits et services")}
//                         </h1>
//                         <div className="row p-2">
//                             <a
//                                 className=" cursor-pointer text-semibold hover:text-gray-500 right-0.5  absolute top-28 mt-8"
//                                 onClick={goToNext}
//                             >
//                                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer  text-gray-300">
//                                     <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
//                                 </svg>
//                             </a>
//                             <a
//                                 className="text-gray-300 cursor-pointer hover:text-gray-500 left-0.5 absolute  top-28 mt-8"
//                                 onClick={goToPrev}
//                             >
//                                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
//                                     <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
//                                 </svg>
//                             </a>
//                             <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
//                                 {serviceContent.map((_, i) => (
//                                     <span
//                                         key={i}
//                                         className={`block h-1  cursor-pointer rounded-2xl transition-all  ${activeIndex === i ? "bg-gray-300 w-8" : "bg-gray-300 w-4"}`}
//                                         onClick={() => setActiveIndex(i)}
//                                     />
//                                 ))}
//                             </div>
//                             {serviceContent.map((service, index) => (
//                                 <div
//                                     key={service.id}
//                                     className={`col-12 col-lg-6 ${activeIndex === index ? "" : "hidden"}`}
//                                 >
//                                     <div className={`rounded-xl m-2 `}>
//                                         <div className='grid grid-cols-5 gap-3 items-center flex justify-center'>
//                                             <div className='col-span-2 flex items-center justify-center'>
//                                                 <img className="rounded-xl h-28 w-28" alt src={service.image != null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} />
//                                             </div>
//                                             <div className='col-span-3 w-full flex flex-wrap justify-start items-center '>
//                                                 <h3 className="title title--h5 text-start text-theme leading-none " style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{service.name}</h3>
//                                                 <div className="w-64 mt-1 text-theme text-about case-item__caption" style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
//                                                     {service.description}
//                                                 </div>
//                                                 <div className="flex items-center justify-center gap-3 mt-2">
//                                                     {service.link != null && (
//                                                         <a target="_blank" href={service.link} className="text-gold text-lg font-bold">
//                                                             {t("Voir")}
//                                                         </a>
//                                                     )}
//                                                     <a
//                                                         onClick={() => {
//                                                             setFindServiceInfo(service.id);
//                                                             setFindServiceModal(true);
//                                                         }}
//                                                         className="text-gold text-lg font-bold"
//                                                     >
//                                                         {t("Details")}
//                                                     </a>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                     {FindServiceModal &&

//                         serviceContent.map(service => {
//                             if (service.id == FindServiceInfo) {
//                                 return (
//                                     <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
//                                         <div className="relative max-h-screen findservice overflow-hidden rounded-xl  sections">
//                                             <div className="absolute -top-3 -right-3 p-4">
//                                                 <a className='w-12 h-12' onClick={() => { setFindServiceModal(false) }}>
//                                                     <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white div-sections opacity-50 rounded-xl cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
//                                                         <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
//                                                     </svg>
//                                                 </a>
//                                             </div>
//                                             <div className="-mt-3">
//                                                 <div className='w-full  h-56 mx-auto'>
//                                                     <img className="cover w-full h-full preview-image   rounded-t-xl " src={service.image != null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} alt="Mountain" />

//                                                 </div>
//                                                 <div className=" px-4 py-4">
//                                                     <div className="font-bold leading-none text-theme text-2xl mb-2">{service.name}</div>
//                                                     <p className="text-theme mt-1 text-about ">{service.description}
//                                                     </p>
//                                                 </div>
//                                                 <div className='flex mb-3 justify-between'>

//                                                     <div className="px-4 pb-2">

//                                                         {service.price != null &&
//                                                             <p className=' text-theme font-bold text-xl'>{service.price} {service.currency}</p>
//                                                         }
//                                                     </div>

//                                                     <div className="px-4 pb-2">
//                                                         {service.link != null &&
//                                                             <a target='_blank' href={service.link} className='text-theme  text-lg font-bold ' >
//                                                                 {t("Voir")} </a>

//                                                         }

//                                                     </div>
//                                                 </div>




//                                             </div>
//                                         </div>
//                                     </div>
//                                 )
//                             }
//                         })


//                     }
//                 </>
//             )}
//         </div>
//     );
// }

// export default Services;

import React, { useState } from 'react';

function Services({
    serviceContent,
    LanguageSelected,
    t,
    ImageUrl,
    hashedUserId,
    FindServiceModal,
    setFindServiceModal,
    img5,
    divstyle
}) {
    const [activeIndex, setActiveIndex] = useState(0);
    const [FindServiceInfo, setFindServiceInfo] = useState(null);

    const goToPrev = () => {
        setActiveIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : serviceContent.length - 1));
    };

    const goToNext = () => {
        setActiveIndex((prevIndex) => (prevIndex < serviceContent.length - 1 ? prevIndex + 1 : 0));
    };

    // Helper to get language-specific text
    const getText = (textObj) => {
        if (!textObj) return '';
        if (typeof textObj === 'object' && textObj !== null) {
            return (
                textObj[LanguageSelected] ||''
            );
        }
        return textObj || '';
    };

    // Check valid content
    const hasValidContent = (service) => {
        const name = getText(service.name);
        const description = getText(service.description);
        return name.trim() !== '' || description.trim() !== '';
    };

    if (!serviceContent || serviceContent.length === 0) return null;

    const validServices = serviceContent.filter(hasValidContent);
    if (validServices.length === 0) return null;

    return (
        <div>
            <div className={`pt-5 pb-5 pl-3 pr-3 relative ${divstyle} w-full`}>
                <h1
                    className={`${
                        LanguageSelected === 'ar'
                            ? 'title title--h1 first-title title__separate text-theme right-2'
                            : 'title left-2 title--h1 first-title title__separate text-theme'
                    }`}
                >
                    {t('Produits et services')}
                </h1>

                <div className="row p-2">
                    {validServices.length > 1 && (
                        <>
                            <a
                                className="cursor-pointer text-semibold hover:text-gray-500 right-0.5 absolute top-28 mt-8"
                                onClick={goToNext}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-6 h-6 cursor-pointer text-gray-300"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M8.25 4.5l7.5 7.5-7.5 7.5"
                                    />
                                </svg>
                            </a>

                            <a
                                className="text-gray-300 cursor-pointer hover:text-gray-500 left-0.5 absolute top-28 mt-8"
                                onClick={goToPrev}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-6 h-6 cursor-pointer text-gray-300"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15.75 19.5L8.25 12l7.5-7.5"
                                    />
                                </svg>
                            </a>
                        </>
                    )}

                    {validServices.length > 1 && (
                        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
                            {validServices.map((_, i) => (
                                <span
                                    key={i}
                                    className={`block h-1 cursor-pointer rounded-2xl transition-all ${
                                        activeIndex === i ? 'bg-gray-300 w-8' : 'bg-gray-300 w-4'
                                    }`}
                                    onClick={() => setActiveIndex(i)}
                                />
                            ))}
                        </div>
                    )}

                    {validServices.map((service, index) => {
                        const serviceName = getText(service.name);
                        const serviceDescription = getText(service.description);

                        return (
                            <div
                                key={service.id}
                                className={`col-12 col-lg-6 ${activeIndex === index ? '' : 'hidden'}`}
                            >
                                <div className="rounded-xl m-2">
                                    <div className="grid grid-cols-5 gap-3 items-center justify-center">
                                        <div className="col-span-2 flex items-center justify-center">
                                            <img
                                                className="rounded-xl h-28 w-28"
                                                alt=""
                                                src={
                                                    service.image != null
                                                        ? `${ImageUrl}/${hashedUserId}/${service.image}`
                                                        : img5
                                                }
                                            />
                                        </div>
                                        <div className="col-span-3 w-full flex flex-wrap justify-start items-center">
                                            <h3
                                                className={`title title--h5 text-theme leading-none ${
                                                    LanguageSelected === 'ar'
                                                        ? 'text-right'
                                                        : 'text-left'
                                                }`}
                                                style={{
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical'
                                                }}
                                                dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                            >
                                                {serviceName || t('Untitled')}
                                            </h3>

                                            <div
                                                className={`w-64 mt-1 text-theme text-about case-item__caption ${
                                                    LanguageSelected === 'ar'
                                                        ? 'text-right'
                                                        : 'text-left'
                                                }`}
                                                style={{
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical'
                                                }}
                                                dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                            >
                                                {serviceDescription}
                                            </div>

                                            <div className="flex items-center justify-center gap-3 mt-2">
                                                {service.link && (
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={service.link}
                                                        className="text-gold text-lg font-bold"
                                                    >
                                                        {t('Voir')}
                                                    </a>
                                                )}

                                                <a
                                                    onClick={() => {
                                                        setFindServiceInfo(service.id);
                                                        setFindServiceModal(true);
                                                    }}
                                                    className="text-gold text-lg font-bold cursor-pointer"
                                                >
                                                    {t('Details')}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {FindServiceModal && (
                <>
                    {validServices.map((service) => {
                        if (service.id === FindServiceInfo) {
                            const serviceName = getText(service.name);
                            const serviceDescription = getText(service.description);

                            return (
                                <div
                                    key={service.id}
                                    className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10"
                                >
                                    <div className="relative max-h-screen findservice overflow-hidden rounded-xl sections">
                                        <div className="absolute -top-3 -right-3 p-4">
                                            <button
                                                className="w-12 h-12"
                                                onClick={() => setFindServiceModal(false)}
                                                aria-label="Close modal"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="h-8 w-8 text-white div-sections opacity-50 rounded-xl cursor-pointer hover:opacity-100 transition-opacity"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>

                                        <div className="-mt-3">
                                            <div className="w-full h-56 mx-auto">
                                                <img
                                                    className="cover w-full h-full preview-image rounded-t-xl"
                                                    src={
                                                        service.image != null
                                                            ? `${ImageUrl}/${hashedUserId}/${service.image}`
                                                            : img5
                                                    }
                                                    alt={serviceName || 'Service image'}
                                                />
                                            </div>

                                            <div className="px-4 py-4">
                                                <div
                                                    className={`font-bold leading-none text-theme text-2xl mb-2 ${
                                                        LanguageSelected === 'ar'
                                                            ? 'text-right'
                                                            : 'text-left'
                                                    }`}
                                                    dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                                >
                                                    {serviceName || t('Untitled')}
                                                </div>
                                                <p
                                                    className={`text-theme mt-1 text-about ${
                                                        LanguageSelected === 'ar'
                                                            ? 'text-right'
                                                            : 'text-left'
                                                    }`}
                                                    dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                                >
                                                    {serviceDescription}
                                                </p>
                                            </div>

                                            <div className="flex mb-3 justify-between">
                                                <div className="px-4 pb-2">
                                                    {service.price && (
                                                        <p className="text-theme font-bold text-xl">
                                                            {service.price} {service.currency}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="px-4 pb-2">
                                                    {service.link && (
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={service.link}
                                                            className="text-theme text-lg font-bold"
                                                        >
                                                            {t('Voir')}
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })}
                </>
            )}
        </div>
    );
}

export default Services;
